/* Boost V2 — Delivery ETA computation + countdown.
   v2.1.0 — 21 May 2026 — international visitors (Pakistan-only shipping) now see the send-to-Pakistan path until they pick a recipient city; city auto-detected + "change" picker (quick-city pills row retired). Still fetches live SLA matrix from Atlas (single source of truth).
   Falls back to a conservative mirror if Atlas is unreachable. Caches 1 min in localStorage.

   Atlas master key: system_settings.delivery_eta_matrix
   Bridge EF: https://zpefopnpabbgvldtvpka.supabase.co/functions/v1/get-delivery-eta-matrix
   Edit SLA: Atlas → Orders → Settings → Delivery SLA.
*/
(function () {
  'use strict';

  /* === ATLAS BRIDGE — live source === */
  var ATLAS_EF_URL = 'https://zpefopnpabbgvldtvpka.supabase.co/functions/v1/get-delivery-eta-matrix';
  var CACHE_KEY = 'boost_sla_cache_v2';
  var CACHE_TTL_MS = 60 * 1000; /* 1 minute */

  /* === FALLBACK SLA CONFIG — used only if Atlas EF unreachable.
        Mirrors Atlas system_settings.delivery_eta_matrix as of 15 May 2026.
        Chief's rules: Karachi 2–3 business days after dispatch · Big PK cities small 4d / chair 7d · Small/far + Quetta + default small 5–6d / chair 10d.
        Days measured AFTER DISPATCH. Sundays + PK holidays skipped.
        LIVE values are fetched from Atlas at page load (see ATLAS_EF_URL). === */
  var FALLBACK_MATRIX = {
    karachi:        { small: { min: 2, max: 3, sameDay: false }, chair: { min: 2, max: 3, sameDay: false } },
    lahore:         { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    islamabad:      { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    rawalpindi:     { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    hyderabad:      { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    faisalabad:     { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    multan:         { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    peshawar:       { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    sialkot:        { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    quetta:         { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    gujranwala:     { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    bahawalpur:     { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    sargodha:       { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    sukkur:         { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    mardan:         { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    sheikhupura:    { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    kasur:          { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    sahiwal:        { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    'rahim-yar-khan': { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    larkana:        { small: { min: 4, max: 4, sameDay: false }, chair: { min: 7, max: 7, sameDay: false } },
    'default':      { small: { min: 5, max: 6, sameDay: false }, chair: { min: 10, max: 10, sameDay: false } }
  };

  var CITY_LABELS = {
    karachi: 'Karachi', lahore: 'Lahore', islamabad: 'Islamabad', rawalpindi: 'Rawalpindi',
    hyderabad: 'Hyderabad', faisalabad: 'Faisalabad', multan: 'Multan', peshawar: 'Peshawar',
    sialkot: 'Sialkot', quetta: 'Quetta',
    gujranwala: 'Gujranwala', bahawalpur: 'Bahawalpur', sargodha: 'Sargodha', sukkur: 'Sukkur',
    mardan: 'Mardan', sheikhupura: 'Sheikhupura', kasur: 'Kasur', sahiwal: 'Sahiwal',
    'rahim-yar-khan': 'Rahim Yar Khan', larkana: 'Larkana',
    'default': 'your city'
  };

  /* These start as fallback values, get replaced by Atlas-fetched values after fetchAtlas() resolves */
  var ETA_MATRIX = FALLBACK_MATRIX;
  var HOLIDAYS = ['2026-03-23','2026-03-30','2026-03-31','2026-05-01','2026-06-06','2026-06-07','2026-08-14','2026-11-09','2026-12-25'];
  var CLOSED_DAY_OF_WEEK = [0]; /* Sunday = 0 (only Sun closed per Chief's rules) */
  var KARACHI_SMALL_CUTOFF_HOUR = 14; /* 2 PM customer-facing */
  var POSTEX_CUTOFF_HOUR = 15;        /* 3 PM for non-Karachi small */
  var LEOPARDS_CUTOFF_HOUR = 14;      /* 2 PM for chairs */
  var FREE_SHIP_THRESHOLD = 0;

  var DAY_NAMES = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var MONTH_NAMES = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  /* === ATLAS LIVE FETCH ===
     Pulls the live SLA from Atlas EF, caches in localStorage 1 min, applies to module-scoped config.
     Fails open — if EF is unreachable, the FALLBACK_MATRIX + hardcoded holidays remain in use. */
  function applyAtlasConfig(settings) {
    try {
      if (settings.delivery_eta_matrix && typeof settings.delivery_eta_matrix === 'object') {
        /* Convert Atlas shape (days_min/days_max/same_day_eligible) → JS shape (min/max/sameDay) */
        var live = {};
        Object.keys(settings.delivery_eta_matrix).forEach(function (city) {
          var src = settings.delivery_eta_matrix[city];
          live[city] = {
            small: { min: src.small.days_min, max: src.small.days_max, sameDay: !!src.small.same_day_eligible },
            chair: { min: src.chair.days_min, max: src.chair.days_max, sameDay: !!src.chair.same_day_eligible }
          };
        });
        ETA_MATRIX = live;
      }
      if (Array.isArray(settings.pk_dispatch_holidays_2026)) {
        HOLIDAYS = settings.pk_dispatch_holidays_2026;
      }
      if (Array.isArray(settings.warehouse_closed_days)) {
        var days = ['sunday','monday','tuesday','wednesday','thursday','friday','saturday'];
        CLOSED_DAY_OF_WEEK = settings.warehouse_closed_days.map(function (d) { return days.indexOf((d || '').toLowerCase()); }).filter(function (n) { return n >= 0; });
      }
      var parseHour = function (val) {
        if (!val) return null;
        var m = String(val).match(/^(\d{1,2}):/);
        return m ? parseInt(m[1], 10) : null;
      };
      var khc = parseHour(settings.delivery_customer_facing_cutoff_karachi_small);
      var px  = parseHour(settings.courier_cutoff_postex);
      var lp  = parseHour(settings.courier_cutoff_leopards);
      if (khc !== null) KARACHI_SMALL_CUTOFF_HOUR = khc;
      if (px  !== null) POSTEX_CUTOFF_HOUR = px;
      if (lp  !== null) LEOPARDS_CUTOFF_HOUR = lp;
    } catch (e) {
      /* If Atlas data is malformed, keep fallback */
      if (window.console && console.warn) console.warn('[BoostDeliveryETA] Atlas config apply failed, using fallback', e);
    }
  }

  function fetchAtlas() {
    /* Try localStorage cache first (1-minute TTL) */
    try {
      var raw = localStorage.getItem(CACHE_KEY);
      if (raw) {
        var cached = JSON.parse(raw);
        if (cached && cached.ts && (Date.now() - cached.ts) < CACHE_TTL_MS && cached.body && cached.body.settings) {
          applyAtlasConfig(cached.body.settings);
          /* Still kick off a background refresh so next page load has fresh data */
          setTimeout(function () { fetchAtlasNetwork(true); }, 100);
          return Promise.resolve(true);
        }
      }
    } catch (_) {}
    return fetchAtlasNetwork(false);
  }

  function fetchAtlasNetwork(silent) {
    if (!window.fetch) return Promise.resolve(false);
    return fetch(ATLAS_EF_URL, { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (body) {
        if (!body || !body.settings) return false;
        applyAtlasConfig(body.settings);
        try { localStorage.setItem(CACHE_KEY, JSON.stringify({ ts: Date.now(), body: body })); } catch (_) {}
        renderKarachiPromises();
        window.dispatchEvent(new CustomEvent('boost:delivery-sla-updated'));
        if (!silent) {
          /* Re-render any widgets already on the page with the live data */
          document.querySelectorAll('[data-bpdp-deta]').forEach(renderForContainer);
        }
        return true;
      })
      .catch(function (e) {
        if (!silent && window.console && console.warn) console.warn('[BoostDeliveryETA] Atlas fetch failed, using fallback', e);
        return false;
      });
  }

  /* === HELPERS === */
  function isoDate(d) {
    var y = d.getFullYear();
    var m = String(d.getMonth() + 1).padStart(2, '0');
    var dd = String(d.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + dd;
  }

  function isClosedDay(d) {
    if (CLOSED_DAY_OF_WEEK.indexOf(d.getDay()) !== -1) return true;
    if (HOLIDAYS.indexOf(isoDate(d)) !== -1) return true;
    return false;
  }

  function nextOpenDay(d) {
    var next = new Date(d);
    while (isClosedDay(next)) {
      next.setDate(next.getDate() + 1);
    }
    return next;
  }

  function addBusinessDays(start, days) {
    if (days <= 0) return new Date(start);
    var d = new Date(start);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      if (!isClosedDay(d)) added++;
    }
    return d;
  }

  function formatDateShort(d) {
    return DAY_NAMES[d.getDay()] + ', ' + d.getDate() + ' ' + MONTH_NAMES[d.getMonth()];
  }

  function formatDateRelative(d, now) {
    var today = new Date(now); today.setHours(0,0,0,0);
    var dCopy = new Date(d); dCopy.setHours(0,0,0,0);
    var diff = Math.round((dCopy - today) / 86400000);
    if (diff === 0) return 'today';
    if (diff === 1) return 'tomorrow';
    return formatDateShort(d);
  }

  function formatBusinessDayBand(tier) {
    var min = Math.max(0, Number(tier && tier.min || 0));
    var max = Math.max(min, Number(tier && tier.max || min));
    if (min === 0 && max === 0) return 'same business day';
    if (min === 0 && max === 1) return 'same or next business day';
    if (min === max) return max + ' business day' + (max === 1 ? '' : 's');
    return min + '–' + max + ' business days';
  }

  function getPromiseText(city, isChair) {
    var cityKey = ETA_MATRIX[city] ? city : 'default';
    var row = ETA_MATRIX[cityKey] || FALLBACK_MATRIX['default'];
    return formatBusinessDayBand(isChair ? row.chair : row.small);
  }

  function renderKarachiPromises() {
    document.querySelectorAll('[data-deta-karachi-promise]').forEach(function (el) {
      el.textContent = getPromiseText('karachi', false);
    });
  }

  /* === CORE ETA COMPUTATION === */
  function computeETA(opts) {
    var city = opts.city;
    var isChair = !!opts.isChair;
    var now = opts.now || new Date();

    var cityKey = ETA_MATRIX[city] ? city : 'default';
    var matrix = ETA_MATRIX[cityKey];
    var tier = isChair ? matrix.chair : matrix.small;

    if (cityKey === 'karachi') {
      tier = {
        min: Math.max(1, tier.min || 1),
        max: Math.max(1, tier.max || 1),
        sameDay: false
      };
    }

    var today = new Date(now);
    var isTodayClosed = isClosedDay(today);

    /* Determine relevant cutoff for THIS product/city combo */
    var cutoffHour;
    if (city === 'karachi' && !isChair) cutoffHour = KARACHI_SMALL_CUTOFF_HOUR;
    else if (isChair) cutoffHour = LEOPARDS_CUTOFF_HOUR;
    else cutoffHour = POSTEX_CUTOFF_HOUR;

    var cutoffMoment = new Date(today);
    cutoffMoment.setHours(cutoffHour, 0, 0, 0);

    var shipDate;
    var shippedSameDay = false;
    var canShipToday = !isTodayClosed && now < cutoffMoment;
    var timeToCutoff = canShipToday ? (cutoffMoment - now) : 0;

    if (canShipToday) {
      shipDate = new Date(today);
      shipDate.setHours(0,0,0,0);
      /* Same-day language is disabled; Karachi uses the live Atlas matrix. */
      if (tier.sameDay) {
        shippedSameDay = true;
      }
    } else {
      var tomorrow = new Date(today);
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0,0,0,0);
      shipDate = nextOpenDay(tomorrow);
    }

    var etaMin, etaMax;
    if (shippedSameDay) {
      etaMin = new Date(today); etaMin.setHours(0,0,0,0);
      etaMax = new Date(etaMin);
    } else {
      etaMin = addBusinessDays(shipDate, tier.min);
      etaMax = addBusinessDays(shipDate, tier.max);
    }

    return {
      etaMin: etaMin,
      etaMax: etaMax,
      shipDate: shipDate,
      shippedSameDay: shippedSameDay,
      canShipToday: canShipToday,
      timeToCutoff: timeToCutoff,
      city: cityKey,
      isFarCity: cityKey === 'default',
      tier: tier
    };
  }

  /* === RENDER === */
  function renderForContainer(container) {
    if (!container) return;
    renderKarachiPromises();
    if (container.dataset.detaIsOos === '1') return; /* server already rendered */
    if (container.dataset.detaIsPreorder === '1') return;

    var isChair = container.dataset.detaIsChair === '1';
    var weightKg = parseFloat(container.dataset.detaWeightKg || '0');
    /* Weight fallback — if Shopify weight is 0 but flagged as chair in Liquid, trust the flag */
    var treatAsChair = isChair || weightKg > 2.0;

    var savedCity = (window.localStorage && localStorage.getItem('boost_geo_city')) || 'karachi';
    savedCity = savedCity.toLowerCase().trim();

    /* International visitor (Boost ships within Pakistan only) — detected by theme.js geo (boost_geo_intl).
       Until they pick a recipient city, offer the send-to-Pakistan path instead of a misleading local date. */
    var showIntlPrompt = false;
    try {
      if (window.localStorage) {
        showIntlPrompt = localStorage.getItem('boost_geo_intl') === '1'
          && localStorage.getItem('boost_geo_city_src') !== 'manual';
      }
    } catch (_) {}

    var result = computeETA({ city: savedCity, isChair: treatAsChair });

    var headlineEl = container.querySelector('[data-deta-headline]');
    var countdownEl = container.querySelector('[data-deta-countdown-text]');
    var countdownWrap = container.querySelector('[data-deta-countdown]');
    var cityLabelEl = container.querySelector('[data-deta-city-label]');

    if (cityLabelEl) {
      cityLabelEl.textContent = showIntlPrompt ? 'Pakistan' : (CITY_LABELS[result.city] || 'your area');
    }

    /* Headline — Chief's rules: always show concrete date, no vague ranges */
    if (headlineEl) {
      var newHead;
      if (showIntlPrompt) {
        newHead = 'We deliver <strong>across Pakistan</strong> — sending a gift to someone in Pakistan? Pick their city for an exact date.';
      } else if (result.city === 'karachi') {
        newHead = 'Karachi delivery <strong>within ' + formatBusinessDayBand(result.tier) + '</strong> after dispatch';
      } else if (result.shippedSameDay) {
        newHead = 'Get it <strong>today</strong> · ' + formatDateShort(result.etaMin);
      } else {
        var minRel = formatDateRelative(result.etaMin, new Date());
        var maxStr = formatDateShort(result.etaMax);
        if (result.etaMin.toDateString() === result.etaMax.toDateString()) {
          /* Flat ETA (e.g. Lahore 4d, chair 7d, chair 10d) — single concrete date */
          if (minRel === 'today' || minRel === 'tomorrow') {
            newHead = 'Get it <strong>' + minRel + '</strong> · ' + maxStr;
          } else {
            newHead = 'Get it on <strong>' + maxStr + '</strong>';
          }
        } else {
          /* Range ETA (Karachi 0-1d, Quetta/default small 5-6d) — show latest */
          newHead = 'Get it by <strong>' + maxStr + '</strong>';
        }
      }
      /* Only rewrite (and re-fire the pop animation) when the text truly changes —
         stops the per-second re-tick from making the headline flash on/off. */
      if (newHead != null && headlineEl.getAttribute('data-deta-head-cur') !== newHead) {
        headlineEl.innerHTML = newHead;
        headlineEl.setAttribute('data-deta-head-cur', newHead);
      }
    }

    /* Countdown — ticks every second for visible urgency */
    if (countdownEl && countdownWrap) {
      if (showIntlPrompt) {
        countdownWrap.classList.add('bpdp-deta-countdown-fired');
        countdownEl.innerHTML = '📍 Tap <strong>change</strong> to choose the delivery city in Pakistan.';
      } else if (result.canShipToday && result.timeToCutoff > 0) {
        countdownWrap.classList.remove('bpdp-deta-countdown-fired');
        var hours = Math.floor(result.timeToCutoff / 3600000);
        var mins = Math.floor((result.timeToCutoff % 3600000) / 60000);
        var secs = Math.floor((result.timeToCutoff % 60000) / 1000);
        var action;
        if (treatAsChair) action = 'to catch today’s Leopards pickup';
        else action = 'to dispatch today';
        var timeStr;
        if (hours > 0) timeStr = hours + 'h ' + String(mins).padStart(2,'0') + 'm ' + String(secs).padStart(2,'0') + 's';
        else if (mins > 0) timeStr = mins + 'm ' + String(secs).padStart(2,'0') + 's';
        else timeStr = secs + 's';
        countdownEl.innerHTML = '⏱️ Order in the next <strong>' + timeStr + '</strong> ' + action;
        /* Pulse on every minute boundary for life */
        if (secs === 59 || secs === 0) {
          countdownWrap.classList.add('bpdp-deta-countdown-pulse');
          setTimeout(function () { countdownWrap.classList.remove('bpdp-deta-countdown-pulse'); }, 1000);
        }
      } else {
        countdownWrap.classList.add('bpdp-deta-countdown-fired');
        var shipRel = formatDateRelative(result.shipDate, new Date());
        countdownEl.innerHTML = '✓ Next dispatch <strong>' + shipRel + '</strong>';
      }
    }

    /* Same-day disclaimer is disabled; the live Atlas matrix is authoritative. */
    var samedayNote = container.querySelector('[data-deta-sameday-note]');
    if (samedayNote) {
      samedayNote.setAttribute('hidden', '');
    }

    /* Live Karachi clock — PKT is UTC+5, render based on visitor's wall clock for honesty */
    var clockEl = container.querySelector('[data-deta-clock-text]');
    if (clockEl) {
      var nowClock = new Date();
      /* Karachi is UTC+5 — convert from visitor's clock for global accuracy */
      var utc = nowClock.getTime() + (nowClock.getTimezoneOffset() * 60000);
      var pkt = new Date(utc + (5 * 3600000));
      var hr12 = pkt.getHours() % 12 || 12;
      var ampm = pkt.getHours() >= 12 ? 'PM' : 'AM';
      var clockStr = String(hr12).padStart(2,'0') + ':' + String(pkt.getMinutes()).padStart(2,'0') + ':' + String(pkt.getSeconds()).padStart(2,'0') + ' ' + ampm;
      clockEl.textContent = clockStr;
    }
  }

  function bindCityModal(container) {
    var btn = container.querySelector('[data-deta-city-btn]');
    var btnSecondary = container.querySelector('[data-deta-city-btn-secondary]');
    var modal = container.querySelector('[data-deta-city-modal]');
    var closeBtn = container.querySelector('[data-deta-city-close]');
    var grid = container.querySelector('[data-deta-city-grid]');
    var citiesRow = container.querySelector('[data-deta-cities-row]');
    if (!btn || !modal || !grid) return;

    function refreshCurrent() {
      var current = (localStorage.getItem('boost_geo_city') || 'karachi').toLowerCase();
      grid.querySelectorAll('button[data-deta-city]').forEach(function (b) {
        if (b.dataset.detaCity === current) b.classList.add('is-current');
        else b.classList.remove('is-current');
      });
      /* Mirror current on the quick-city pills row */
      if (citiesRow) {
        citiesRow.querySelectorAll('button[data-deta-quick-city]').forEach(function (b) {
          if (b.dataset.detaQuickCity === current) b.classList.add('is-current');
          else b.classList.remove('is-current');
        });
      }
    }

    function openModal() {
      refreshCurrent();
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', 'open');
    }

    btn.addEventListener('click', openModal);
    if (btnSecondary) btnSecondary.addEventListener('click', openModal);

    /* Quick-city pill row — click any pill, instantly set city + re-render ETA */
    if (citiesRow) {
      citiesRow.addEventListener('click', function (e) {
        var target = e.target.closest('button[data-deta-quick-city]');
        if (!target) return;
        var newCity = target.dataset.detaQuickCity;
        localStorage.setItem('boost_geo_city', newCity);
        document.querySelectorAll('[data-bpdp-deta]').forEach(renderForContainer);
        refreshCurrent();
        window.dispatchEvent(new CustomEvent('boost:city-changed', { detail: { city: newCity } }));
      });
    }
    /* Initial sync */
    refreshCurrent();

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        if (typeof modal.close === 'function') modal.close();
        else modal.removeAttribute('open');
      });
    }

    grid.addEventListener('click', function (e) {
      var target = e.target.closest('button[data-deta-city]');
      if (!target) return;
      var newCity = target.dataset.detaCity;
      localStorage.setItem('boost_geo_city', newCity);
      try { localStorage.setItem('boost_geo_city_src', 'manual'); } catch (_) {}
      if (typeof modal.close === 'function') modal.close();
      else modal.removeAttribute('open');
      /* Re-render all delivery widgets on the page + broadcast event */
      document.querySelectorAll('[data-bpdp-deta]').forEach(renderForContainer);
      window.dispatchEvent(new CustomEvent('boost:city-changed', { detail: { city: newCity } }));
    });

    /* Cross-tab sync */
    window.addEventListener('storage', function (e) {
      if (e.key === 'boost_geo_city') {
        document.querySelectorAll('[data-bpdp-deta]').forEach(renderForContainer);
      }
    });
  }

  function tick() {
    document.querySelectorAll('[data-bpdp-deta]').forEach(renderForContainer);
  }

  function init() {
    var containers = document.querySelectorAll('[data-bpdp-deta]');
    /* Render immediately with fallback values so widget is never blank */
    renderKarachiPromises();
    containers.forEach(function (c) {
      renderForContainer(c);
      bindCityModal(c);
    });
    /* Fetch live Atlas config on every page so FAQ/home/product promises share
       the Order SLA master even when a page has no delivery widget. */
    fetchAtlas().then(function (ok) {
      if (!ok) return;
      renderKarachiPromises();
      document.querySelectorAll('[data-bpdp-deta]').forEach(renderForContainer);
    });
    /* Re-tick every second so countdown + clock stay live */
    if (containers.length) setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Expose for re-renders triggered by variant changes etc. */
  window.BoostDeliveryETA = {
    rerender: tick,
    compute: computeETA,
    getPromiseText: getPromiseText,
    getKarachiPromise: function () { return getPromiseText('karachi', false); },
    renderPromises: renderKarachiPromises
  };
})();
